'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
function ValidationsComponent($filter) {
	'ngInject';

	var service = {
		'numberValidation': numberValidation,
		'textValidation': textValidation,
		'emailValidation': emailValidation,
		'phoneValidation': phoneValidation
	};

	return service;

	/** */
	function phoneValidation(value, e) {
		if (e) {
			var numb = angular.element(e.target.nextElementSibling);

			if (phoneValidationRegex(value) && typeof value !== 'undefined') {
				numb.css({ 'opacity': '0' });
			} else if (typeof value === 'undefined' || value === '') {
				numb.css({ 'opacity': '0' });
			} else {
				numb.text($filter('translate')('ERRORS.REQUIRED_VALID_PHONE')).css({ 'position': 'relative', 'color': 'red', 'opacity': '1' });
			}
		} else {
			return phoneValidationRegex(value);
		}
	}

	/** */
	function phoneValidationRegex(value) {
		var regex = /\+?\d+/;

		return regex.test(value);
	}

	/** */
	function numberValidation(value, e) {
		if (e) {
			var numb = angular.element(e.target.nextElementSibling);

			if (numberValidationRegex(value) && typeof value !== 'undefined') {
				numb.css({ 'opacity': '0' });
			} else if (typeof value === 'undefined' || value === '') {
				numb.css({ 'opacity': '0' });
			} else {
				numb.text($filter('translate')('ERRORS.ONLY_NUMBERS')).css({ 'position': 'relative', 'color': 'red', 'opacity': '1' });
			}
		} else {
			return numberValidationRegex(value);
		}
	}

	/** Validate only numbers */
	function numberValidationRegex(value) {
		var regex = /^[0-9]+$/;
		return regex.test(value);
	}

	/** */
	function textValidation(value, e) {
		if (e) {
			var text = angular.element(e.target.nextElementSibling);

			if (textValidationRegex(value) && value !== '') {
				text.css({ 'opacity': '0' });
			} else if (value === '') {
				text.css({ 'opacity': '0' });
			} else {
				text.text($filter('translate')('ERRORS.ONLY_STRINGS')).css({ 'position': 'relative', 'color': 'red', 'opacity': '1' });
			}
		} else {
			return textValidationRegex(value);
		}
	}
	/** Validation only strings a-z */
	function textValidationRegex(value) {
		var regex = /^[A-Za-z\s]+$/;
		return regex.test(value);
	}

	/** */
	function emailValidation(value, e) {
		if (e) {
			var text = angular.element(e.target.nextElementSibling);

			if (emailValidationRegex(value) && value !== '') {
				text.css({ 'opacity': '0' });
			} else if (value === '') {
				text.css({ 'opacity': '0' });
			} else {
				text.text($filter('translate')('ERRORS.REQUIRED_VALID_EMAIL')).css({ 'position': 'relative', 'color': 'red', 'opacity': '1' });
			}
		} else {
			return emailValidationRegex(value);
		}
	}
	/** Validation only email address*/
	function emailValidationRegex(value) {
		var regex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
		return regex.test(value);
	}
}
exports['default'] = ValidationsComponent;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/components/validator/validator.service.js
 **/